import { render } from "./AdvancedComponents.vue?vue&type=template&id=52eee87e&scoped=true"
import script from "./AdvancedComponents.vue?vue&type=script&lang=js"
export * from "./AdvancedComponents.vue?vue&type=script&lang=js"

import "./AdvancedComponents.vue?vue&type=style&index=0&id=52eee87e&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-52eee87e"]])

export default __exports__